import { useOnce } from '@mentimeter/react-hooks';
import { userCache } from '@mentimeter/user';
import { postRecentRequest } from '@core-api/presentation-collection/presentation-collection/recent';

export const useRegisterViewSeries = (
  seriesId: string,
  shouldRegisterView: boolean,
) => {
  useOnce(shouldRegisterView, async () => {
    const region = userCache.region;
    const sessionToken = userCache.getToken();

    try {
      await fetch(
        postRecentRequest({ region, userAuth: sessionToken, id: seriesId }),
      );
    } catch {
      // Swallow the error, as it's not critical for the user experience
    }
  });
};
